import { httpClient } from '../../../shared/configs/http-client'

export const getDevices = async () => {
  const { data } = await httpClient.get<{ usb: string[] }>(`http://localhost:1337/api/devices`)

  return data
}